import { colors } from '@alixpartners/ui-components';
import styled from 'styled-components';

export const MenuSection = styled.div`
	border-bottom: 1px solid ${colors.grey3};

	&:first-child {
		margin-top: 8px;
	}

	&:last-child {
		border: none;
	}

	button:first-child {
		margin-top: 0;
	}
`;
